import { Box } from '@chakra-ui/react'
import React from 'react'

const ClientSpecificTag = () => {
  return (
    <Box
      as="span"
      display="inline-block"
      mb="2px"
      ml="xsmall"
      color="black"
      bg="#F8D557"
      borderRadius="full"
      fontSize="10px"
      px="5px"
      verticalAlign="middle"
    >
      Client-specific
    </Box>
  )
}

export default ClientSpecificTag
